// NOTE: These values represent i18n translation keys
export enum FileSize {
	NA = 'filesize.na',
	BYTES = 'filesize.bytes',
	KB = 'filesize.kb',
	MB = 'filesize.mb',
	GB = 'filesize.gb',
	TB = 'filesize.tb',
}

export interface SpecificFileSize {
	quantity: number;
	size: FileSize;
}

export function bytesToSize(bytes: number | null): SpecificFileSize {
	const sizes: FileSize[] = [
		FileSize.BYTES,
		FileSize.KB,
		FileSize.MB,
		FileSize.GB,
		FileSize.TB,
	];
	if (bytes === 0 || bytes === null) {
		return {
			quantity: 0,
			size: FileSize.KB,
		};
	}
	const i: number = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
	if (i === 0) {
		return {
			quantity: bytes,
			size: sizes[i],
		};
	}
	return {
		quantity: (bytes / (1024 ** i)),
		size: sizes[i],
	};
}
